import { createContext } from 'react';

export const HeaderExternalElementContext = createContext<HTMLElement | null>(null);
